import React from 'react';
import { MembershipLandingViewV2 } from 'views/rebranded-module/membership-module/MembershipLandingViewV2';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { defaultNS } from 'next-i18next.config';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import isCrawlers from 'lib/utils/isCrawlers';
import { API } from 'lib/config/axios';
import { serverFetch } from 'lib/utils/serverFetch';
import { getPreferredSeoIdentifer } from 'lib/utils/getPreferredSeoIdentifer';
import { HydrationWrapper } from 'views/common/components';
import MobileDetect from 'mobile-detect';
import { useSelector } from 'react-redux';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';
import { cmsServerFetch } from 'lib/utils/cmsServerFetch';
import { membershipLandingCMSQuery } from 'views/rebranded-module/membership-module/MembershipLandingViewV2/utils/membershipLandingPageQuery';

const MembershipLandingPage = (props) => {
  const { serverData, cmsData } = props;
  const isCrawler = useSelector((state) => state.globalData.isCrawler);
  if (isCrawler) {
    return (
      <HydrationWrapper>
        <ContentContext.Provider value={cmsData}>
          <MembershipLandingViewV2 serverData={serverData} />
        </ContentContext.Provider>
      </HydrationWrapper>
    );
  }
  return (
    <ContentContext.Provider value={cmsData}>
      <MembershipLandingViewV2 serverData={serverData} />
    </ContentContext.Provider>
  );
};
export async function getServerSideProps(ctx) {
  const { req, locale, query } = ctx;
  if (query.force_old_page_load === '1') {
    ctx.res.statusCode = 503;
    return {
      props: {},
    };
  }
  const userAgent = req.headers['user-agent'];

  const hreflangData = generateHreflang(
    PATHS.motorcycleClub.index().url,
    locale,
  );
  const ssrRender = isCrawlers(userAgent);
  let layoutData = null;
  let serverData = null;
  let serverError = null;
  let cmsData = null;

  // need to add cmsRes agin here const [layoutRes, pageRes, cmsRes ]   when add cms
  const [layoutRes, pageRes, cmsRes] = await Promise.all([
    serverFetch(ctx, API.layout, query),
    serverFetch(ctx, API.membership.index, {
      preferred_seo_identifer: getPreferredSeoIdentifer(
        ctx.req.url,
        ctx.locale,
      ),
      ...query,
    }),
    cmsServerFetch(ctx, membershipLandingCMSQuery),
  ]);
  if (layoutRes.success) {
    layoutData = layoutRes.data;
  }
  if (pageRes.success) {
    serverData = pageRes.data;
  } else {
    serverError = {
      statusCode: pageRes.error.response.status,
    };
  }

  if (cmsRes.success) {
    cmsData = cmsRes.cmsData;
  }

  if (serverError) {
    ctx.res.statusCode = serverError.statusCode;
  }
  let deviceType;
  const md = new MobileDetect(userAgent);
  if (md.tablet()) {
    deviceType = 'tablet';
  } else if (md.mobile()) {
    deviceType = 'mobile';
  } else {
    deviceType = 'desktop';
  }
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[ctx.locale], [
        ...defaultNS,
        'membership_landing_V2_page',
        'common_rentals_card',
        'common_plan_card_v2',
        'common_participating_locations',
      ])),
      hreflangData,
      layoutData,
      serverData,
      serverError,
      ssrRender,
      deviceType,
      cmsData,
      options: {
        showAiChat: true,
        transparentNavBar: true,
      },
      rebrandingPage: true,
    },
  };
}
export default MembershipLandingPage;
